import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { authenticate } from './functions/jsFunctions.js'

const app = createApp(App).use(router)
var auth = await authenticate(localStorage.msc)

//Check Authenitcation
router.beforeEach(async (to, from, next) => 
{
    if(to.matched.some(record => record.meta.requiresAuth))
    {  
        //Global Properties
        if(auth)
        {
            app.config.globalProperties.status = "active"
            next()
        }
        else
            next({name: "login", replace: true})
    }
    else 
        next()
})

app.provide('Name', auth.fName)
app.provide('Group', auth.group)
app.provide('Logo', auth.logo)
app.mount('#app')